/**
 * @typedef {import('../model/brand-affilate-account').BrandAffiliateAccount } BrandAffiliateAccount
 * @typedef {import('../model/sponsor').Sponsor} Sponsor
 * @typedef {import('../model/signup-schema').SignupSchema } SinupSchema
 * @typedef {import('../model/signup-type').SignupType } SignupType
 * @typedef {import('../model/market').Market } Market
 */

const notImplementedMessage = 'Not Implemented';

/** Base class for signup client */
export default class SignupClientBase {
    /* istanbul ignore next */
    /**
     * Create a new signup session
     * @param {Object} p
     * @param {string} p.entrypoint
     * @param {string} p.market
     * @param {string} p.language
     * @param {string} p.signupType
     * @param {string} p.referrer
     * @return {Promise<string>} session ID
     */
    async createSession({
        entrypoint,
        market,
        language,
        signupType,
        referrer
    }) {
        throw new Error(notImplementedMessage);
    }

    /**
     * @type {string | null}
     */
    get currentSessionId() {
        return null;
    }

    /**
     * @param {string | null} value
     */
    set currentSessionId(value) {
    }

    /**
     * Call the sponsor lookup by sponsorId
     *
     * @param {string} sponsorId the sponsor id to look up
     * @param {string} [inviteId] invitation ID
     * @return {Sponsor[]} the sponsor data
     * @throws {Error} for general errors
     * @throws {HttpError} for HTTP/REST errors
     */
    async sponsorLookup(sponsorId, inviteId) {
        throw new Error(notImplementedMessage);
    }

    /**
     * Call the getSponsorAccounts in signup-api to get all associated (BB/BC) accounts
     * @param {*} sponsorId
     * @param {Market} market The market for the call
     * @param {string} language The language for the call
     */
    async getSponsorAccounts(sponsorId, market, language) {
        throw new Error(notImplementedMessage);
    }

    /**
     * Retrieves the signup from schema from AEM.
     * @param {Market} market The market for the form
     * @param {SignupType} signupType The signupType (e.g. BRAND_AFFILIATE)
     * @param {string} language The language for the form
     */
    async getSignupSchema(market, signupType, language) {
        throw new Error(notImplementedMessage);
    }

    /**
     * Create an account based on signupType and market
     * @param {Market} market
     * @param {SignupType} signupType
     * @param {string} language
     * @param {Object} modelObject
     * @param {string} [inviteId] invitation ID
     */
    async createAccount(market, signupType, language, modelObject, inviteId) {
        throw new Error(notImplementedMessage);
    }

    /**
     * @typedef {Object} GovtID
     * @property {string} type the type of government Id
     * @property {string} value the id string
     */

    /**
     * @typedef {Object} GuestData
     * @property {string} firstName the first name value
     * @property {string} lastName the last name value
     * @property {string} email the email for the guest account
     * @property {GovtID} [govtID] the tax id if any
     * @property {string} sponsorId the sponsor id for the account
     * @property {string} origin the origin code for the signup
     */

    /**
     * @param {Market} market the market for the guest account
     * @param {string} language the preferred language for the guest account
     * @param {GuestData} guestData the data for the guest account
     */
    async createGuestAccount(market, language, guestData) {
        throw new Error(notImplementedMessage);
    }
}
